import { Injectable, isDevMode } from '@angular/core';
import { FirebaseService } from '../service/firebase.service';
import { Router } from '@angular/router';
import { Subject, BehaviorSubject } from 'rxjs';
import * as semver from 'semver'

@Injectable({
  providedIn: 'root'
})
export class SharedService {


  user: any;
  public selectedDevice: any = null;
  public modulesArray: any = [];
  public configForm: any = {};

  public groupsArray: any = [];
  public groupArraySub$: any = new Subject<any>();
  public devicesArray: any = [];
  public devicesArraySub$: any = new Subject<any>()
  public mediaLanguageArray: Array<Object> = [
    { name: 'English', tag: 'en' }
  ];

  public observerSelectedDevice: Subject<any> = new Subject<any>();
  color: any;
  uploadEvent: any = null;
  uploadFolder: any = null;
  urlToNameArray: any = [];

  limitImg: number = 50;

  public nameModule: any = {
    'kiosk': 'Kiosk',
    'quiz': 'Questionnaires',
    'data': 'Données',
    'form': 'Formulaire de contact',
    'media': 'Média'
  }
  public defaultFolder: any;


  constructor(
    private firebaseService: FirebaseService,
    private router: Router) {
  }

  checkIfAvailable(type) {
    //Proximum
    let availableList = ['lEeOibslLMXnpnPM1vHrgtNymq92', 'TW0LZKlTEkPeU2up4L462QVlWtk1'];

    if (type == 'michelin')
      availableList.push('V0lWR5Q8ndOPVvas88sAoiHGfLu2')


    if (type == 'ofb') {
      availableList.push('6budstAuZHRkOQr9rwwbsFWvyB83')
    }

    if (type == 'sogea') {
      availableList.push('QqSGO0yD7kUjhO7UC0Kn91iEJ2A3')
    }
    if (type == 'equinix') {
      availableList.push('1EljyUzx1AN6Vj4EMtKw2WIqg4o2')
    }
    // console.log(this._firebase.user.uid)
    if (isDevMode() || this.firebaseService.user.role == 'admin' || availableList.includes(this.firebaseService.user.uid))
      return true;
    else
      return false;

    //  else if (this._shareVar.user)
  }

  /**
   * Initialize firebase connection
   * */
  public firebaseInit() {
    this.firebaseService.userCheck.subscribe(data => {

      console.log(data)
      if (data.uid != null && !data.assignedDevice) {
        this.firebaseService.getAllGroupsFromUser().then(data => {
          this.groupsArray = data.sort(function (a, b) {

            //console.log(a, b)
            if (a.name > b.name)
              return 1;
            if (a.name < b.name)
              return -1;

            return 0;
          });
          console.log(this.groupsArray)
          this.groupArraySub$.next(this.groupsArray);
        });

        this.firebaseService.getAllDevicesFromUser().then(data => {


          let resData = data.filter(v => {

            if (v.data.hideDevice != true)
              return v;
            else
              return null

          }
          )

          // console.log(resData)
          this.devicesArray = resData.sort(function (a, b) {
            if (a.data.name > b.data.name)
              return 1;
            if (a.data.name < b.data.name)
              return -1;

            return 0;
          });

          this.devicesArraySub$.next(this.devicesArray);
          console.log("DEVICE ARRAY", this.devicesArray)

          //     this.devicesArray =  this.devicesArray.splice(0, 1)

        })
      }
      else {

        this.firebaseService.getAllDevicesFromUser().then(data => {


          let resData = data.filter(v => {

            if (v.data.hideDevice != true)
              return v;
            else
              return null

          }
          )

          // console.log(resData)
          this.devicesArray = resData.sort(function (a, b) {
            if (a.data.name > b.data.name)
              return 1;
            if (a.data.name < b.data.name)
              return -1;

            return 0;
          });


          if (this.devicesArray.length == 1) {
            console.log("NEED TO FIND GROUP", this.devicesArray[0])

            this.firebaseService.getGroupsFromId(this.devicesArray[0].data.groupId).then(data => {

              console.log(data)
              this.groupsArray = data.sort(function (a, b) {

                //console.log(a, b)
                if (a.name > b.name)
                  return 1;
                if (a.name < b.name)
                  return -1;

                return 0;
              });

              console.log("NEXT", this.groupsArray)
              this.groupArraySub$.next(this.groupsArray);
            })


          }
          this.devicesArraySub$.next(this.devicesArray);
          console.log("DEVICE ARRAY", this.devicesArray)
          //     this.devicesArray =  this.devicesArray.splice(0, 1)

        })

      }
    })
  }



  checkAppVersion(versionTarget: string, appType: string) {

    if (!versionTarget)
      return true;

    let appTypeKey;

    switch (appType) {
      case 'media':
        appTypeKey = 'appMediaVersion'
        break;

    }



    if (semver.satisfies(this.firebaseService.user[appTypeKey], `>= ${versionTarget}`) || isDevMode())
      return true
    else
      return false;
  }

  public getDeviceArray() {
    return this.devicesArray
  }

  /**
   * Submit global device's configuration
   * */

  public submit(latestUpdate = null) {

    console.log(latestUpdate)

    let oldConfig = JSON.parse(JSON.stringify(this.configForm))


    /* this.firebaseService.checkModifTimestamp(oldConfig.latestUpdate, this.selectedDevice.id, 'devices').then(d => {
       if (d) {
         console.log("CAN CHANGE ELEMENT", oldConfig.latestUpdate)
       }
     })*/
    /* NEED TO CHECK IF DISTANT CONFIG FOR UPDATE IS EQUAL TO OLDCONFIGFORM */


    //console.log(oldConfig.latestUpdate)
    this.configForm.latestUpdate = new Date();






    return new Promise((resolve, reject) => {
      let promiseTab = [];

      if (this.configForm.timerSlideshow < 1)
        this.configForm.timerSlideshow = 1;

      if (this.configForm.listBackgrounds == undefined)
        this.configForm.listBackgrounds = [];


      //console.log()
      if (this.uploadEvent != null && this.uploadFolder != null && this.configForm.listBackgrounds.length <= this.limitImg) {


        this.firebaseService.uploadFiles(this.uploadEvent.target.files, this.uploadFolder).then((preData) => {
          console.log(preData)
          let data = [];
          let fullBackgroundData = []
          preData.forEach((d) => {
            //console.log(d)
            data.push(d.url);
            fullBackgroundData.push({ defaultName: d.defaultName, url: d.url })
          })

          //console.log("LSIT BACKGROUND:", data, preData)

          if (this.configForm.listBackgrounds == undefined || this.configForm.listBackgrounds.length <= 0)
            this.configForm.listBackgrounds = data;
          else
            this.configForm.listBackgrounds = this.configForm.listBackgrounds.concat(data)


          if (this.configForm.fullListBackgrounds == undefined || this.configForm.listBackgrounds.length <= 0)
            this.configForm.fullListBackgrounds = fullBackgroundData;
          else
            this.configForm.fullListBackgrounds = this.configForm.fullListBackgrounds.concat(fullBackgroundData);
          this.uploadEvent = null;
          this.uploadFolder = null;

          //console.log(this.configForm)

          console.log("SHARED VAR LATEST UPDATE", latestUpdate);
          this.firebaseService.updateConfigModule({ config: this.configForm, latestUpdate: latestUpdate }, this.selectedDevice.id, 'devices').then(d => {

            console.log(d)
            resolve(d);
          }).catch(err => {
            reject(err);
          })


          /* this.firebaseService.updateConfigDevice(this.configForm, this.selectedDevice.id).then(d => {
             resolve();
           }).catch(err => {
             reject(err);
           })*/

        });



        /* Array.from(this.uploadEvent.target.files).forEach((item, index) => {
           promiseTab.push(this.firebaseService.uploadFiles(item, this.uploadFolder))
         })*/

        /*   Promise.all(promiseTab).then((preData) => {
   
   
           })*/
      }
      else {
        //console.log(this.configForm)
        console.log("SHARED VAR LATEST UPDATE", latestUpdate);
        this.firebaseService.updateConfigModule({ config: this.configForm, latestUpdate: latestUpdate }, this.selectedDevice.id, 'devices').then(d => {
          console.log(d)
          resolve(d);
        }).catch(err => {
          reject(err);
        })
        /* this.firebaseService.updateConfigDevice(this.configForm, this.selectedDevice.id).then(d => {
           resolve();
         }).catch(err => {
           reject(err);
         })*/
      }


    })



  }

  getWeekDays(locale) {
    var baseDate = new Date(Date.UTC(2017, 0, 2)); // just a Monday
    var weekDays = [];
    for (let i = 0; i < 7; i++) {
      weekDays.push(baseDate.toLocaleDateString(locale, { weekday: 'long' }));
      baseDate.setDate(baseDate.getDate() + 1);
    }
    return weekDays;
  }



  setMetadateFromImage() {
    this.urlToNameArray = [];
    this.selectedDevice.data.config.listBackgrounds.forEach((item) => {
      this.firebaseService.getMetadataFromUrl(item).then(d => {
        this.urlToNameArray.push({ url: item, name: d.name })
      })
    })
  }



  /**
   *
   * Set the current selected device
   * 
   * @param device The device config data
   */

  public setActiveBorne(device) {

    this.modulesArray = [];

    for (var property in device.data.modules) {
      if (device.data.modules.hasOwnProperty(property) && device.data.modules[property]) {
        this.modulesArray.push(property)
      }
    }
    this.selectedDevice = device;


    this.firebaseService.selectedDeviceFirebaseService = device;


    if (device.data.config != undefined)
      this.configForm = device.data.config;
    else
      this.configForm = {
        startText: 'Touchez l\'écran pour démarrer !', colorText: 'FFFFFF', inactivity: 60, password: '0000', backgroundURL: ''
      };

    console.log(this.selectedDevice)
    this.observerSelectedDevice.next(this.selectedDevice)
    this.setMetadateFromImage()
    //console.log(this.firebaseService.user.uid)
    if (this.modulesArray.includes('mapcontent') && this.firebaseService.user.uid == 'hh2gXimSbxO0iZmrLctln60SGHg2') {
      this.router.navigate(['/mapcontent']);
    }
    else {
      this.router.navigate(['/global']);
    }


  }



}


